import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MessagesModule } from 'primeng/messages';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CarouselModule } from 'primeng/carousel';
import { TagModule } from 'primeng/tag';
import { StepsModule } from 'primeng/steps';

@NgModule({
    declarations: [],
    imports: [CommonModule, TooltipModule, ButtonModule, RippleModule, TabMenuModule, TabViewModule, DropdownModule, AutoCompleteModule, MenuModule, TableModule, PaginatorModule, DialogModule, CheckboxModule, RadioButtonModule, MessagesModule, MessagesModule, AccordionModule, CalendarModule, MultiSelectModule, ConfirmDialogModule, CarouselModule, TagModule, StepsModule],
    exports: [TooltipModule, ButtonModule, RippleModule, TabMenuModule, TabViewModule, DropdownModule, AutoCompleteModule, MenuModule, TableModule, PaginatorModule, DialogModule, CheckboxModule, RadioButtonModule, MessagesModule, MessagesModule, AccordionModule, CalendarModule, MultiSelectModule, ConfirmDialogModule, CarouselModule, TagModule, StepsModule]
})
export class PrimengModule {}
